/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A single time-series bucket for skill usage activity
 */
export type SkillTimeSeriesPoint = {
  /**
   * Bucket start time in Unix nanoseconds (string for JS int64 precision)
   */
  bucketStartNs: string;
  /**
   * Number of skill use events in this bucket
   */
  eventCount: number;
  /**
   * Skill name
   */
  skillName: string;
};

/** @internal */
export const SkillTimeSeriesPoint$inboundSchema: z.ZodMiniType<
  SkillTimeSeriesPoint,
  unknown
> = z.pipe(
  z.object({
    bucket_start_ns: z.string(),
    event_count: z.int(),
    skill_name: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "bucket_start_ns": "bucketStartNs",
      "event_count": "eventCount",
      "skill_name": "skillName",
    });
  }),
);

export function skillTimeSeriesPointFromJSON(
  jsonString: string,
): SafeParseResult<SkillTimeSeriesPoint, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SkillTimeSeriesPoint$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SkillTimeSeriesPoint' from JSON`,
  );
}
